import React from 'react';
import T from 'i18n-react';

import MetaTags from 'Components/MetaTags/MetaTags';
import { DiscoverMWPayPage } from 'Components/StaticPages/DiscoverMWPay';
import texts from 'Components/texts.json';

import metaImage from '../public/static/images/og-discover-motorway-pay.png';

T.setTexts(texts);

const MotorwayPay = (): React.ReactElement => (
	<>
		<MetaTags
			// @ts-ignore needs to rewrite MetaTags to TS, and stop using withRouter for it to work
			imagePrependHost
			noIndex
			description={T.translate('metaTags.pages.discoverMotorwayPay.description')}
			height={metaImage.height}
			image={metaImage.src}
			title={T.translate('metaTags.pages.discoverMotorwayPay.title')}
			width={metaImage.width}
		/>
		<DiscoverMWPayPage />
	</>
);

export default MotorwayPay;
